export default __webpack_public_path__ + "static/media/insurance_7.0ac22c72.png";